document.addEventListener("DOMContentLoaded", (event) => {
  // Select the element with the class 'megamenu-hover'
  var megaMenuHover = document.querySelector(".megamenu-hover");

  // Add 'mouseenter' event listener to add the 'active' class
  megaMenuHover.addEventListener("mouseenter", function () {
    this.classList.add("active");
  });

  // Add 'mouseleave' event listener to remove the 'active' class
  megaMenuHover.addEventListener("mouseleave", function () {
    this.classList.remove("active");
  });
});
